import { ConservationStatus, GriisStatus } from '../types/graph/project';

export enum IUCNStatus {
    LEAST_CONCERN = 'Least Concern',
    NEAR_THREATENED = 'Near Threatened',
    VULNERABLE = 'Vulnerable',
    ENDANGERED = 'Endangered',
    CRITICALLY_ENDANGERED = 'Critically Endangered',
    EXTINCT_IN_THE_WILD = 'Extinct in the Wild',
    EXTINCT = 'Extinct',
    DATA_DEFICIENT = 'Data Deficient',
    NOT_EVALUATED = 'Not Evaluated',
    NOT_FOUND = 'Not Found',
    INVASIVE = 'Invasive',
}

export enum IUCNStatusCode {
    LC = 'LC',
    NT = 'NT',
    VU = 'VU',
    EN = 'EN',
    CR = 'CR',
    EW = 'EW',
    EX = 'EX',
    DD = 'DD',
    NE = 'NE',
    NF = 'NF',
}

export const iucnStatusData: { [key: string]: { label: string; rank: number; code: string } } = {
    CR: { label: 'Critically Endangered', rank: 1, code: IUCNStatusCode.CR },
    EN: { label: 'Endangered', rank: 2, code: IUCNStatusCode.EN },
    VU: { label: 'Vulnerable', rank: 3, code: IUCNStatusCode.VU },
    IN: { label: 'Invasive', rank: 4, code: 'IN' },
    NT: { label: 'Near Threatened', rank: 5, code: IUCNStatusCode.NT },
    LC: { label: 'Least Concern', rank: 6, code: IUCNStatusCode.LC },
    NE: { label: 'Not Evaluated', rank: 7, code: IUCNStatusCode.NE },
    DD: { label: 'Data Deficient', rank: 8, code: IUCNStatusCode.DD },
    EX: { label: 'Extinct', rank: 9, code: IUCNStatusCode.EX },
    EW: { label: 'Extinct in the Wild', rank: 10, code: IUCNStatusCode.EW },
    NF: { label: 'Not Found', rank: 11, code: IUCNStatusCode.NF },
};

/** The categories that count on the Red List (CR/EN/VU/NT — DD-5480). */
export const isRedListCategory = (status: string): boolean =>
    [IUCNStatusCode.CR, IUCNStatusCode.EN, IUCNStatusCode.VU, IUCNStatusCode.NT].includes(status as IUCNStatusCode);

export const getIucnCodeFromLabel = (label: string): string | undefined => {
    for (const code in iucnStatusData) {
        if (iucnStatusData[code].label === label) {
            return code;
        }
    }
    return undefined;
};

export const getIucnCodeFromStatus = (status: string) => {
    return Object.values(iucnStatusData).find(entry => entry.label === status)?.code;
};

export const getConservationStatusTag = (conservationStatus: Partial<ConservationStatus>) => {
    const iucnStatus = conservationStatus?.iucnRedListStatus || '';
    const chegdGroup = conservationStatus?.chegdGroup || '';
    const isInvasive = [conservationStatus?.onGRIISList === GriisStatus.INVASIVE, conservationStatus?.onGRIISList === true].some(Boolean);

    if (
        iucnStatus &&
        [iucnStatusData.CR.code, iucnStatusData.EN.code, iucnStatusData.VU.code, iucnStatusData.NT.code].includes(iucnStatus)
    ) {
        return {
            iucnStatusLabel: iucnStatusData[iucnStatus].label,
            iucnStatusRank: iucnStatusData[iucnStatus].rank,
            iucnStatusType: 'redList',
            chegdGroup,
            isInvasive,
        };
    } else if (iucnStatus) {
        return {
            iucnStatusLabel: iucnStatusData[iucnStatus].label,
            iucnStatusRank: iucnStatusData[iucnStatus].rank,
            iucnStatusType: 'default',
            isInvasive,
            chegdGroup,
        };
    } else {
        return { iucnStatusLabel: '', iucnStatusRank: 20, iucnStatusType: '', isInvasive, chegdGroup };
    }
};
